import React, { memo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal } from '../Modal';
import { Button } from '../Button';
import { T } from '../../translation/src';
import { ShieldExclamationIcon } from '@heroicons/react/24/outline';

interface PermissionDeniedOverlayProps {
  open: boolean;
  onClose: () => void;
}

const PermissionDeniedOverlay_: React.FC<PermissionDeniedOverlayProps> = ({ open, onClose }) => {
  const navigate = useNavigate();

  const handleClose = () => {
    navigate('/');
    onClose();
  };

  return (
    <Modal.Container open={open} onClose={handleClose} panelClassName="max-w-md">
      <Modal.Header className="flex items-center justify-center space-x-2">
        <ShieldExclamationIcon className="w-8 h-6 text-red-500" />
        <T _str="Access Denied" />
      </Modal.Header>
      <Modal.Body>
        <div className="text-center">
          <p className="text-gray-600 dark:text-gray-300 mb-4">{<T _str="You don't have sufficient permissions. Please contact your administrator if you believe this is an error." />}</p>
        </div>
      </Modal.Body>
      <Modal.Footer className="justify-center">
        <Button variant="secondary" onClick={handleClose}>
          <T _str="Close" />
        </Button>
      </Modal.Footer>
    </Modal.Container>
  );
};

export const PermissionDeniedOverlay = memo(PermissionDeniedOverlay_);
